module.exports = __webpack_public_path__ + "img/basic.181195a7.png";